/** Default footer “Events by Category” columns (used when Site Labels JSON is empty/invalid). */
import { normalizeFooterCategoryItem } from './footerCategoryItem.js';

export const DEFAULT_FOOTER_EVENT_CATEGORY_GROUPS = [
  {
    heading: 'Trending',
    items: [
      { label: 'Kedarkantha Trek', search: 'Kedarkantha Trek' },
      { label: 'Valley of Flowers', search: 'Valley of Flowers' },
      { label: 'Hampta Pass', search: 'Hampta Pass' },
      { label: 'Sar Pass Trek', search: 'Sar Pass Trek' }
    ]
  },
  {
    heading: 'Region',
    items: [
      { label: 'Himalayas', search: 'Himalayas' },
      { label: 'Himachal Pradesh', search: 'Himachal Pradesh' },
      { label: 'Uttarakhand', search: 'Uttarakhand' },
      { label: 'Kashmir', search: 'Kashmir' }
    ]
  },
  {
    heading: 'Experience',
    items: [
      { label: 'High Altitude Trek', search: 'High Altitude Trek' },
      { label: 'Snow Trek', search: 'Snow Trek' },
      { label: 'Backpacking', search: 'Backpacking' },
      { label: 'Camping', search: 'Camping' }
    ]
  },
  {
    heading: 'Duration',
    items: [
      { label: 'Weekend Getaways', search: 'Weekend' },
      { label: 'Long Expeditions', search: 'Expedition' },
      { label: 'Day Hikes', search: 'Day Hike' },
      { label: 'Summer Camps', search: 'Summer Camp' }
    ]
  }
];

/**
 * @param {string} raw — JSON from site_settings.footer_events_categories
 */
export function parseFooterEventCategoryGroups(raw) {
  const fallback = DEFAULT_FOOTER_EVENT_CATEGORY_GROUPS;
  if (!raw || typeof raw !== 'string') return fallback;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || !parsed.length) return fallback;
    const groups = parsed
      .map((g) => ({
        heading: String(g?.heading || '').trim(),
        items: (Array.isArray(g?.items) ? g.items : [])
          .map((item) => normalizeFooterCategoryItem(item))
          .filter((item) => {
            if (!item.label) return false;
            const hasTreks = item.trekSlugs && item.trekSlugs.length;
            const hasSearch = String(item.search || '').trim();
            return hasTreks || hasSearch;
          })
      }))
      .filter((g) => g.heading && g.items.length);
    return groups.length ? groups : fallback;
  } catch {
    return fallback;
  }
}

export { footerCategoryItemHref, getFooterItemTrekSlugs } from './footerCategoryItem.js';
